import React, { useContext } from 'react';

import * as FormSelectors from 'Pages/manageproduction/helpers/formSelectors';
import { ProductionRecordDetailFieldEnum as ProdRecordDetailFields } from 'Common/FieldEnum';

import { CountSection } from './CountSection';
import { EditProductionFormContext } from './EditProductionForm';

function OfferedSection(props) {
  const state = useContext(EditProductionFormContext);
  const recipeCategoryIds = Object.keys(props.detailsByRecipeCategory);
  const offeredTotalByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.Offered,
    recipeCategoryIds
  );

  const offeredAdultTotalByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.OfferedAdult,
    recipeCategoryIds
  );
  const offeredAlacarteTotalByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.OfferedAlacarte,
    recipeCategoryIds
  );

  const offeredPreKTotalByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.OfferedPreK,
    recipeCategoryIds
  );    

  return (
    <CountSection
      {...props}
      headerProps={{
        offeredTotalByRecCat,
        offeredAdultTotalByRecCat,
        offeredAlacarteTotalByRecCat,
        offeredPreKTotalByRecCat,
      }}
    />
  );
}

export { OfferedSection };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/OfferedSection.js